import { ref } from 'vue';
import { useSmallScreen } from './useSmallScreen';

// Estado de sessao (nao grava em ui_settings): no celular o painel de contato
// comeca fechado mesmo se o desktop estiver com ele aberto. Sem isso, abrir
// uma conversa no celular caia no CRM em vez da conversa.

const mobileContactOpen = ref(false);
const mobileComposerAction = ref(null);

export function useMobileConversationUi() {
  const { isSmallScreen, windowWidth } = useSmallScreen();

  const openMobileContact = () => {
    mobileContactOpen.value = true;
  };

  const closeMobileContact = () => {
    mobileContactOpen.value = false;
  };

  const resetMobileContact = () => {
    mobileContactOpen.value = false;
  };

  const requestComposerAction = action => {
    mobileComposerAction.value = action;
  };

  const consumeComposerAction = () => {
    const action = mobileComposerAction.value;
    mobileComposerAction.value = null;
    return action;
  };

  return {
    isSmallScreen,
    windowWidth,
    mobileContactOpen,
    mobileComposerAction,
    openMobileContact,
    closeMobileContact,
    resetMobileContact,
    requestComposerAction,
    consumeComposerAction,
  };
}
